<template>
    <div class="content">
        <van-swipe :lazy-render="true" class="banner" :autoplay="3000" indicator-color="white">
            <van-swipe-item><img src="../../../public/img/products/1.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/products/3.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/products/4.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/products/5.jpg"></van-swipe-item>
            <van-swipe-item><img src="../../../public/img/products/2.jpg"></van-swipe-item>
        </van-swipe>

        <h6 class="title_g">
            {{title[0]}}
            <br>
            <p>{{title[1]}}</p>
        </h6>

        <!-- 0-加载中 -->
        <van-skeleton v-if="status === 0" title :row="3" style="margin-bottom: 3rem"/>
        <!-- 1-无数据 -->
        <div class="nodata" v-else-if="status === 1">
            <img src="../../../public/img/nodata.svg" width="100%">
            <span>No data</span>
        </div>
        <!-- 2-加载完成 -->
        <van-list
            v-else-if="status === 2"
            v-model="loading"
            :finished="productList.length >= total"
            finished-text="--End--"
            @load="onLoad"
            class="list-box"
        >
            <van-cell v-for="(item, key) in productList" :key="key">
                <ProductItem :info="item"/>
            </van-cell>
        </van-list>
        <!-- 3-加载失败 -->
        <div class="nodata" v-else-if="status === 3">
            <img src="../../../public/img/fail.svg" width="100%">
            <span>Error</span>
        </div>
    </div>
</template>

<script>
import {
    List as VanList,
    Cell as VanCell,
    Swipe as VanSwipe,
    SwipeItem as VanSwipeItem,
    Skeleton as VanSkeleton,
} from 'vant';
import ProductItem from './item.vue';
import axios from 'axios';

export default {
    name: 'Exhibition',
    data() {
        return {
            status: 0,          // 页面状态 0-加载中，1-无数据，2-加载完成，3-加载失败
            productList: [],    // 产品列表
            currentPage: 1,     // 当前加载出的页码
            total: 0,           // 总数
            loading: false,
        }
    },
    methods: {
        async loadProduct() {
            // 如果目前产品列表数量，大于等于总数量，则不加载
            if (this.total && this.productList.length >= this.total) return

            let reqData = {}

            // 根据关键词搜索
            if (this.keyword) {
                reqData = {
                    "page": this.currentPage,
                    "rows": 10,
                    "sort": "CreateDate",
                    "order": "desc",
                    "wheres": "[{\"name\":\"redModel\",\"value\":\"" + this.$route.query.keyword + "\",\"displayType\":\"like\"}]"
                }
            }
            // 根据分组搜索
            else {
                reqData = {
                    "page": this.currentPage,
                    "rows": 10,
                    "sort": "CreateDate",
                    "order": "desc",
                    "wheres": "[{\"name\":\"group_Id\",\"value\":\"" + this.elid + "\"}]"
                }
            }

            // 如果当前是第一页，清空产品列表
            if (this.currentPage === 1) {
                this.productList = []
            }

            try {
                const response = await axios.post('/api/Alibaba_Product/GetProductData', reqData);

                const data = response.data.data.rows;
                this.total = response.data.data.total;
                this.loading = false;
                // 无数据
                if (data.length === 0) {
                    this.status = 1
                }
                // 有数据
                else {
                    this.status = 2

                    data.forEach(i => {
                        this.productList.push({
                            imgs: [i.image1Url, i.image2Url, i.image3Url, i.image4Url, i.image5Url],
                            itemNo: i.redModel,
                            desc: i.subject,
                            price: i.fobPrice,
                            qty: `${i.moq} ${i.units || ''}`
                        })
                    })
                }
            } catch (e) {
                // 请求失败
                this.status = 3;
            }
        },
        onLoad() {
            this.currentPage++;
            this.loadProduct();
        }
    },
    computed: {
        elid() {
            if (this.$route.query.id) {
                return this.$route.query.id
            } else {
                return this.$store.state.defaultCatalogId
            }
        },
        keyword() {
            return this.$route.query.keyword
        },
        title() {
            if (this.keyword) {
                return [`RESULTS FOR '${this.keyword || ' '}'`, '']
            } else {
                return this.$store.state.catalogName.split('|')
            }
        }
    },
    watch: {
        elid: {
            immediate: true,
            handler: function() {
                this.status = 0;
                this.currentPage = 1;
                this.loading = true;
                this.productList = [];
                this.total = 0;

                this.loadProduct();
            }
        },
        keyword() {
            this.status = 0;
            this.currentPage = 1;
            this.loading = true;
            this.productList = [];
            this.total = 0;

            this.loadProduct();
        }
    },
    components: { VanSwipe, VanSwipeItem, VanList, VanCell, ProductItem, VanSkeleton }
}
</script>

<style lang="less" scoped>
    .nodata { width: 8rem; display: block; margin: 2rem auto; text-align: center; color: #aeb8c2; }
    .banner img { width: 100%; }

    .list-box { padding: 0 8px; }
    .list-box > div { vertical-align: top; padding: 0 3px; width: 50%; display: inline-block; box-sizing: border-box; margin-bottom: 2rem; }

    /deep/ .van-cell { font-size: 1rem; line-height: normal; overflow: inherit; }
    /deep/ .van-cell:after { width: calc(100% - 6px); left: 3px; bottom: -10px; }
</style>